import React, { useEffect, useState, useMemo } from "react";
import {
  Grid,
  useMediaQuery,
  Checkbox,
} from "@material-ui/core";

import { useTranslation } from "react-i18next";
import PdfReader from '../../../pures/adobePfdReader/PdfReader'

import "./contract-generated.css";
import { ButtonHLPure, CheckBoxTemplatePure, DialogPdf, DialogPdfHLPure, FormDatePicker, InputFileHLPure, InputHLPure, TooltipHLPure, Traslates, DropDownBtnHLPure, InputSwitchHLPure } from "../../../pures";
import { InputDecimal } from "./InputDecimal-componente";
import { SignRequestByVolumeStepThreeIcon, DocumentsRequest } from "../../../../assets/logos/icons";
import { ClientContractService } from "../../../../services";
import { changeFormatNumberToSend, changeFormatNumberToShow } from "../../../../utils/convertFormatAnswer";
import { b64toBlob } from "./../../../../validators";
import { RadioButton } from "@progress/kendo-react-inputs";

const ContractGeneratedView = (props) => {

  const {
    hideShowDetails,
    status,
    setUrlPdf,
    setQuestionsAnswered,
    questions,
    clientContractId,
    token,
    showLoadingRequesting,
    toggleLoadingRequesting,
    showCompletedRequesting,
    toggleCompletedRequesting,
    showErrorRequesting,
    toggleErrorRequesting,
    heightContainer,
    userHasPermission,
    handleFile,
    handleDeleteFile,
    selectedFile,
    selectedFileName,
    errorFile,
    showAWS,
    handleShowModal,
    urlPdfModal,
    showModalPdf,
    documentSelected,
    handleCloseModal,
    handleUpdateAnswerRawRecDoc
  } = props

  const { t } = useTranslation();

  const url = process.env.REACT_APP_MIFIRMA_API;
  const clientContractService = new ClientContractService(url);

  const mobileResolution = useMediaQuery("(max-width:660px)");


  const [state, setState] = useState([]);
  const [selectedLogic, setSelectedLogic] = useState({
    name: "",
    selected: false
  })
  const [showRadioOptions, setShowRadioOptions] = useState(undefined);
  const [pdfDialog, setPdfDialog] = useState(false)
  const [questionSelected, setQuestionSelected] = useState({})
  const [currentSystem, setCurrentSystem] = useState("");
  const [isLoadingModalPdf, setIsLoadingModalPdf] = useState(false)
  const [selectedFileBase64, setSelectedFileBase64] = useState(props.selectedFileBase64)
  const [blobUrl, setBlobUrl] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const pdfAws = useMemo(() => <PdfReader className="pdfReader" url={urlPdfModal} awsURL src={urlPdfModal}  ></PdfReader>, [urlPdfModal])
  const pdf = useMemo(() => <PdfReader className="pdfReader" file={props.selectedFileBase64} isFile src={`data:application/pdf;base64,${props.selectedFileBase64}`}  ></PdfReader>, [props.selectedFileBase64])


  let heightContainerModal = mobileResolution ? 450 : 650
  let widthContainerModal = mobileResolution ? 550 : 1000
  let heightBodyModal = mobileResolution ? 230 : 400

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");



  const heightContainerInputs = heightContainer ? heightContainer : '470px'
  const inputStyles = {
    padding: '10px 15px 10px 15px',
    maxHeight: heightContainerInputs,
    overflowY: 'auto',
    overflowX: 'hidden'
  }


  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (props.selectedFileBase64) {
      const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
      setBlobUrl(blob);
      setSelectedFileBase64(props.selectedFileBase64)
    }
  }, [props.selectedFileBase64]);

  useEffect(() => {
    if (questions && questions.length > 0) {
      if (status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100512)) {
        let copyQuestions = [...questions]
        let questionsNew = copyQuestions.filter((question) => question.isForContractor === true)
        setState(questionsNew)
        setQuestionsAnswered(questionsNew)
      } else {
        setState(questions)
        setQuestionsAnswered(questions)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, questions])

  const handleChange = (e, i) => {
    let { value } = e.target;
    const name = "value";
    const newState = [...state];
    if (newState[i].formatVariable.key === 'uppercase') {
      value = value.toUpperCase()
    }
    newState[i] = {
      ...newState[i],
      [name]: value,
    };
    setState(newState);
    setQuestionsAnswered(newState)
  };

  const handleChangeDecimal = (e, i) => {
    let { value } = e.target;
    value = value.replace(/([^0-9.]+)/, "");
    value = value.replace(/^(0|\.)/, "");
    const name = "value";
    const newState = [...state];

    newState[i] = {
      ...newState[i],
      [name]: value,
    };

    setState(newState);
    setQuestionsAnswered(newState)
  };

  const onChangeDatepicker = (e, i) => {
    const { value } = e.target;
    const name = "value";
    const newState = [...state];
    newState[i] = {
      ...newState[i],
      [name]: value,
    };
    setState(newState);
    setQuestionsAnswered(newState)
  }

  const handleClickBack = () => {
    hideShowDetails()
  }

  const handleOpenDialogPDF = (doc) => {
    let url = doc.url
    setUrlPdf(url)
    setPdfDialog(true)
  }


  const onBlur = async (e, index) => {
    let messageError = ''
    const newState = [...state];
    let questionelected = newState[index]
    let answerList = []

    if (questionelected.value === null) return false
    let value = questionelected.format === 'text' ? questionelected.value.trim() : questionelected.value
    const name = "value";
    newState[index] = {
      ...newState[index],
      [name]: value
    };
    answerList = [...newState]

    try {
      let answer = await clientContractService.saveAnswersQuestionsContract(clientContractId, answerList, token)
      if (!answer || Number(answer.statusCode) !== 200) {
        messageError = "No se pudo guardar la respuesta correctamente"
        throw new Error(messageError);
      }
    } catch (error) {
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  }


  const onBlurDecimal = async (e, index) => {
    let { value } = e.target
    value = value.trim()
    value = value.replaceAll(',', '')
    let name = "value";
    let messageError = ''
    let newState = [...state];
    let answerList = []
    let questionelected = newState[index]
    let id = newState[index].formatVariable.id
    let asnwerToShow = changeFormatNumberToShow(value, id)
    let answerToSend = changeFormatNumberToSend(value, id)

    if (questionelected.value === null) return false
    newState[index] = {
      ...newState[index],
      [name]: answerToSend
    };
    answerList = [...newState]

    try {
      let answer = await clientContractService.saveAnswersQuestionsContract(clientContractId, answerList, token)
      if (!answer || Number(answer.statusCode) !== 200) {
        messageError = "No se pudo guardar la respuesta correctamente"
        throw new Error(messageError);
      }
      newState[index] = {
        ...newState[index],
        [name]: asnwerToShow,
      };
      newState[index].formatValue = asnwerToShow
      setState(newState);
      setQuestionsAnswered(newState)
    } catch (error) {
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 4000)
    }
  }

  const handleChangeRadio = (e, i) => {
    const newState = [...state];
    const { value } = e;
    setSelectedValue(e.value)
    newState.filter((question) => question.questionGroup === newState[i].questionGroup)
    newState.map((question) => {
      if (question.questionGroup === newState[i].questionGroup) {
        if (question.level === 2) {
          if (question.name === value) {
            question.value = true
          } else {
            question.value = false
          }
        }
        if (question.level === 3) {
          let numberMap = question.order.split('.')[1]
          let numberQuestion = newState[i].order.split('.')[1]
          if (Number(numberMap) === Number(numberQuestion)) {
            question.disabled = false
          } else {
            question.disabled = true
          }
        }
      }
      return question
    })
    setState(newState);
    setQuestionsAnswered(newState)
  }

  const onBlurRadio = async (e, index) => {
    let messageError = "No se pudo guardar la respuesta correctamente"
    const newState = [...state];
    const { value } = e.target;
    let name = "value";
    let questionSelected = newState[index]
    let answerList = []
    let questionsSameGroup = newState.filter((question) => question.questionGroup === questionSelected.questionGroup && question.level === questionSelected.level)
    for (let index = 0; index < questionsSameGroup.length; index++) {
      let answer = questionsSameGroup[index].value;
      let questionFormat = questionsSameGroup[index].format;
      let answerToSend = answer;

      if (questionFormat === 'number') {
        if (typeof answer !== "number") {
          answer = answer.replaceAll(",", "");
        }
        answerToSend = changeFormatNumberToSend(answer, questionFormat);
      }

      newState[index] = {
        ...newState[index],
        [name]: answerToSend
      };
      answerList = [...newState]
      // for (let j = 0; j < questionsSameGroup[index].answers.length; j++) {
      //   let info = {};
      //   if (questionsSameGroup[index].level === 2) {
      //     if (questionsSameGroup[index].name === value) {
      //       answerToSend = 'true'
      //     } else {
      //       answerToSend = 'false'
      //     }
      //   }

      //   info.answer = answerToSend;
      //   info.id = questionsSameGroup[index].answers[j].answerId;
      //   answerList.push(info);
      // }

      try {
        let answer = await clientContractService.saveAnswersQuestionsContract(clientContractId, answerList, token)
        if (!answer || Number(answer.statusCode) !== 200) {
          throw new Error(messageError);
        }
      } catch (error) {
        toggleErrorRequesting(true, messageError)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 3000)
      }
    }
  }

  const onChangeCheckBox = (e, i) => {
    const { value } = e.target;
    const name = "value";
    const newState = [...state];
    newState[i] = {
      ...newState[i],
      [name]: value,
    };
    setState(newState);
    setQuestionsAnswered(newState)
  }


  const onBlurCheckBox = async (e, index) => {
    let { checked } = e.target
    let value = checked
    let messageError = ''
    const newState = [...state];
    let questionSelected = newState[index]
    let answerList = []

    for (let index = 0; index < questionSelected.answers.length; index++) {
      let info = {}
      info.id = questionSelected.answers[index].answerId
      info.answer = value
      answerList.push(info)
    }

    try {
      let answer = await clientContractService.saveAnswersQuestionsContract(clientContractId, answerList, token)
      if (!answer || Number(answer.statusCode) !== 200) {
        messageError = "No se pudo guardar la respuesta correctamente"
        throw new Error(messageError);
      }
    } catch (error) {
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  }

  const handleChangeDropDown = async (e, index, type, indexOption) => {
    let { value } = e.target;
    let newState = [...state];
    if (type === t("questionnairesAdministrationEditQuestionView.selector.check.single")) {
      newState[index].value = value
      newState[index].selectorOptions.options = newState[index].selectorOptions.options.map((option) => {
        option.value = (option.name === value) ? true : false
        return option
      })
    } else {
      value = newState[index].selectorOptions.options[indexOption].name
      let valueTemp = ''
      newState[index].selectorOptions.options = newState[index].selectorOptions.options.map((option) => {
        if (option.name === value) {
          option.value = !option.value
        }

        if (option.value) {
          if (!valueTemp) {
            valueTemp = option.name
          } else {
            valueTemp = `${valueTemp}, ${option.name}`
          }
        }
        return option
      })
      newState[index].value = valueTemp
    }
    setState(newState);
    setQuestionsAnswered(newState)
    let messageError = "No se pudo guardar la respuesta correctamente"
    try {
      let answer = await clientContractService.saveAnswersQuestionsContract(clientContractId, newState, token)
      if (!answer || Number(answer.statusCode) !== 200) {

        throw new Error(messageError);
      }
    } catch (error) {
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  }

  const handleChangeLogic = async (e, index, value) => {
    const newState = [...state]
    newState[index].questionLogic.selectedLogic = value
    // const foundState = newState[index].optionsLogic.find(item => item.value !== value)
    // foundState.value = !foundState.value
    newState[index].optionsLogic.map((option) => {
      option.value = !option.value
      return
    })
    newState[index].value = value ? newState[index].questionLogic.truly : newState[index].questionLogic.falsy

    setState(newState);
    setQuestionsAnswered(newState)

    let messageError = "No se pudo guardar la respuesta correctamente"
    try {
      let answer = await clientContractService.saveAnswersQuestionsContract(clientContractId, newState, token)
      if (!answer || Number(answer.statusCode) !== 200) {

        throw new Error(messageError);
      }
    } catch (error) {
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  }

  return (
    <div className="contractGeneratedDetailsView-wrapper">
      <Grid
        item
        className="contractGeneratedDetailsView-body"
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
      >
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="contractGenerated-containerQuestions"
        >
          <div className="" style={inputStyles}>
            {
              state.map((item, index) => {
                let paddingQuestion = '0px'
                switch (item.level) {
                  case 2:
                    paddingQuestion = '20px'
                    break;
                  case 3:
                    paddingQuestion = '50px'
                    break;
                  default:
                    paddingQuestion = '0px'
                    break;
                }
                if (item.formatVariable.key === process.env.REACT_APP_FORMAT_VARIABLES_KEY_SELECTOR) {
                  return (
                    item.selectorOptions && item.selectorOptions.type && item.selectorOptions.type.length > 1 && (
                      item.selectorOptions.type[0].value ? (
                        <div className="contractGenerated-selector">
                          <DropDownBtnHLPure
                            labelDropDown={item.name}
                            optionsDropDown={item.selectorOptions.options || []}
                            optionsValue={item.value || ''}
                            valueItem={"name"}
                            nameOption={"name"}
                            onDropDownChange={(e) => handleChangeDropDown(e, index, item.selectorOptions.type[0].name)}
                          />
                          <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                        </div>
                      ) : (
                        <div className="contractGenerated-logic">
                          <label className="dropDownBtnHLPure-label">
                            {item.name}
                          </label>
                          {
                            item && item.selectorOptions && item.selectorOptions.options && item.selectorOptions.options.length > 0 && item.selectorOptions.options.map((option, indexOption) =>
                              <CheckBoxTemplatePure
                                label={option.name}
                                id={option.name}
                                name={option.name}
                                value={option.value || false}
                                checked={option.value || false}
                                onChange={(e) => handleChangeDropDown(e, index, item.selectorOptions.type[1].name, indexOption)}
                              />
                            )
                          }
                          <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                        </div>
                      )
                    )
                  )

                } else if (item.formatVariable.key === process.env.REACT_APP_FORMAT_VARIABLES_KEY_LOGIC) {
                  return (
                    <div className="contractGenerated-logic">
                      <label className="dropDownBtnHLPure-label">
                        {item.name}
                      </label>
                      {item && item.optionsLogic.length > 0 && <div className="contractGenerated-logic-switch">
                        <InputSwitchHLPure
                          customClass="contractGenerated-logic-switch-display"
                          labelInput={item.questionLogic.selectedLogic ? item.questionLogic.truly : item.questionLogic.falsy}
                          checked={item.questionLogic.selectedLogic}
                          onChange={(e) => handleChangeLogic(e, index, !item.questionLogic.selectedLogic)}
                        />
                      </div>
                      }
                      <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                    </div>
                  )
                } else if (item.fieldType.key === 'fieldTypeText' && item.format === 'text' && (item.formatVariable.key === 'simpleText' || item.formatVariable.key === 'uppercase')) {
                  return (
                    <div className="contractGeneratedDetailsView-questions" style={{ paddingLeft: paddingQuestion }}>
                      {
                        item.documentsRequired.length > 0 || item.documentsRequest.length > 0 ?
                          <div className="contractGeneratedDetailsView-container-icons">
                            <InputHLPure
                              typeInput={"text"}
                              labelInput={item.name}
                              valueInput={item.value}
                              inputActive
                              disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                              onBlur={(e) => onBlur(e, index)}
                              handleChangeInput={(e) => handleChange(e, index)}
                            // handleChangeInput={() => setShowRadioQuestion(true)}
                            />
                            <div className="contractGeneratedDetailsView-icons-container">
                              {
                                item.documentsRequired.map((doc, index) => {
                                  return (
                                    <div className="contractGeneratedDetailsView-container-question-icon-pdf">
                                      <i style={{ cursor: 'pointer' }} onClick={() => handleOpenDialogPDF(doc)}>
                                        <img className="contractGeneratedDetailsView-icon-pdf" alt="Logo de govo.legal" src={SignRequestByVolumeStepThreeIcon} />
                                      </i>
                                      <TooltipHLPure
                                        positionTooltip={'right'}
                                        titleTooltip={'Mostrar documento'}
                                        descriptionTooltip={doc.name}
                                        subContent={''}
                                        restContent={''}
                                        informationIcon={true}
                                      />
                                    </div>
                                  )
                                })
                              }
                              {
                                item.documentsRequest.map((documento, index) => {
                                  return (
                                    <div className="contractGeneratedDetailsView-icon-upload-container">
                                      <i style={{ cursor: 'pointer' }} onClick={() => handleShowModal(documento)}>
                                        <img className="contractGeneratedDetailsView-icon-upload" alt="upload document in question" src={DocumentsRequest} />
                                      </i>
                                      <TooltipHLPure
                                        positionTooltip={'right'}
                                        titleTooltip={'Subir documento'}
                                        descriptionTooltip={documento.name}
                                        subContent={''}
                                        restContent={''}
                                        informationIcon={true}
                                      />
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                          :
                          <InputHLPure
                            typeInput={"text"}
                            labelInput={item.name}
                            valueInput={item.value}
                            inputActive
                            disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                            onBlur={(e) => onBlur(e, index)}
                            handleChangeInput={(e) => handleChange(e, index)}
                          // handleChangeInput={() => setShowRadioQuestion(true)}
                          />
                      }
                      <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                    </div>
                  );
                } else if (item.fieldType.key === 'fieldTypeText' && item.format === 'text' && item.formatVariable.key === 'onlyQuestion') {
                  return (
                    <div className="contractGeneratedDetailsView-questions" style={{ paddingLeft: paddingQuestion }}>
                      <label className="inputHLPure-label" name="label">
                        {item.name}
                      </label>
                      <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                    </div>
                  )
                } else if (item.fieldType.key === 'fieldTypeText' && item.format === 'number') {
                  return (
                    <div className="contractGeneratedDetailsView-questions" style={{ paddingLeft: paddingQuestion }}>
                      {
                        item.documentsRequired.length > 0 || item.documentsRequest.length > 0 ?
                          <div className="contractGeneratedDetailsView-container-icons">
                            <InputDecimal
                              className="inputHLPure-input"
                              type="text"
                              valueInput={item.value}
                              disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                              onBlur={(e) => onBlurDecimal(e, index)}
                              labelInput={item.name}
                              idFormat={item.format}
                              onChange={(e) => handleChangeDecimal(e, index)}
                            />
                            <div className="contractGeneratedDetailsView-icons-container">
                              {
                                item.documentsRequired.map((doc, index) => {
                                  return (
                                    <div className="contractGeneratedDetailsView-container-question-icon-pdf">
                                      <i style={{ cursor: 'pointer' }} onClick={() => handleOpenDialogPDF(doc)}>
                                        <img className="contractGeneratedDetailsView-icon-pdf" alt="Logo de govo.legal" src={SignRequestByVolumeStepThreeIcon} />
                                      </i>
                                      <TooltipHLPure
                                        positionTooltip={'right'}
                                        titleTooltip={'Mostrar documento'}
                                        descriptionTooltip={doc.name}
                                        subContent={''}
                                        restContent={''}
                                        informationIcon={true}
                                      />
                                    </div>
                                  )
                                })
                              }
                              {
                                item.documentsRequest.map((documento, index) => {
                                  return (
                                    <div className="contractGeneratedDetailsView-icon-upload-container">
                                      <i style={{ cursor: 'pointer' }} onClick={() => handleShowModal(documento)}>
                                        <img className="contractGeneratedDetailsView-icon-upload" alt="upload document in question" src={DocumentsRequest} />
                                      </i>
                                      <TooltipHLPure
                                        positionTooltip={'right'}
                                        titleTooltip={'Subir documento'}
                                        descriptionTooltip={documento.name}
                                        subContent={''}
                                        restContent={''}
                                        informationIcon={true}
                                      />
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                          :
                          <InputDecimal
                            className="inputHLPure-input"
                            type="text"
                            valueInput={item.value}
                            disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                            onBlur={(e) => onBlurDecimal(e, index)}
                            labelInput={item.name}
                            idFormat={item.format}
                            onChange={(e) => handleChangeDecimal(e, index)}

                          />
                      }
                      <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                    </div>
                  );
                } else if (item.fieldType.key === "fieldTypeText" && item.format === "date") {
                  return (
                    <div className="contractGeneratedDetailsView-questions" style={{ paddingLeft: paddingQuestion }}>
                      <div className="contractGeneratedDetailsView-container-icons">
                        <label className="contractGeneratedDetailsView-label-date" name="label">
                          {item.name}
                        </label>
                        <div className="contractGeneratedDetailsView-icons-container">
                          {
                            item.documentsRequired.map((doc, index) => {
                              return (
                                <div className="contractGeneratedDetailsView-container-question-icon-pdf">
                                  <i style={{ cursor: 'pointer' }} onClick={() => handleOpenDialogPDF(doc)}>
                                    <img className="contractGeneratedDetailsView-icon-pdf" alt="Logo de govo.legal" src={SignRequestByVolumeStepThreeIcon} />
                                  </i>
                                  <TooltipHLPure
                                    positionTooltip={'right'}
                                    titleTooltip={'Mostrar documento'}
                                    descriptionTooltip={doc.name}
                                    subContent={''}
                                    restContent={''}
                                    informationIcon={true}
                                  />
                                </div>
                              )
                            })
                          }
                          {
                            item.documentsRequest.map((documento, index) => {
                              return (
                                <div className="contractGeneratedDetailsView-icon-upload-container">
                                  <i style={{ cursor: 'pointer' }} onClick={() => handleShowModal(documento)}>
                                    <img className="contractGeneratedDetailsView-icon-upload" alt="upload document in question" src={DocumentsRequest} />
                                  </i>
                                  <TooltipHLPure
                                    positionTooltip={'right'}
                                    titleTooltip={'Subir documento'}
                                    descriptionTooltip={documento.name}
                                    subContent={''}
                                    restContent={''}
                                    informationIcon={true}
                                  />
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                      <Traslates>
                        <FormDatePicker
                          id={"date"}
                          name={"date"}
                          format="dd-MMM-yyyy"
                          required={true}
                          title={t("signatureRequestView2.tooltipLimitDate")}
                          defaultValue={item.value && item.value !== '' ? new Date(item.value) : ''}
                          disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                          onBlur={(e) => onBlur(e, index)}
                          onChange={(e) => onChangeDatepicker(e, index)}
                        />
                      </Traslates>
                      <p className="contractGeneratedDetailsView-hlep-text">{item.helpText}</p>
                    </div>
                  );
                } else if (item.fieldType.key === 'fieldTypeRadio' && (item.formatVariable.key === 'simpleText' || item.formatVariable.key === 'uppercase')) {
                  return (
                    <div className="contractGeneratedDetailsView-questions" style={{ paddingLeft: paddingQuestion }}>
                      <RadioButton
                        name={item.questionGroup}
                        value={item.name}
                        checked={selectedValue === item.name || item.value === 'true'}
                        label={item.name}
                        disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                        onChange={(e) => handleChangeRadio(e, index)}
                        onBlur={(e) => onBlurRadio(e, index)}
                      />
                    </div>
                  )
                } else if (item.fieldType.key === 'fieldTypeCheckbox' && (item.formatVariable.key === 'simpleText' || item.formatVariable.key === 'uppercase')) {
                  return (
                    <div className="contractGeneratedDetailsView-questions" style={{ paddingLeft: paddingQuestion }}>
                      <Checkbox
                        value={(item.value === 'true') ? true : false}
                        label={item.name}
                        disabled={(status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) || status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599) || !userHasPermission || item.disabled) ? true : false}
                        onChange={(e) => onChangeCheckBox(e, index)}
                        onBlur={(e) => onBlurCheckBox(e, index)}
                      />
                    </div>
                  )
                } else {
                  return
                }
              })
            }
          </div>
        </Grid>
      </Grid>
      {
        isMobile ? (
          <div className="contractGenerated-container-back-btn">
            <ButtonHLPure
              nameBtn={t('button.return')}
              primary={true}
              onClickBtn={handleClickBack}
            />
          </div>
        ) : null
      }
      {showModalPdf && (
        <DialogPdfHLPure
          title={t("signatureRequestView2.uploadDocument")}
          description={`Cargar documento ${documentSelected.name}`}
          saveBtn={t("signatureRequestView2.uploadDocument")}
          canelBtn={t("button.cancel")}
          width={widthContainerModal}
          height={heightContainerModal}
          heightBody={heightBodyModal}
          handleFile={handleFile}
          handleDeleteFile={handleDeleteFile}
          cancel={handleCloseModal}
          handleSubmitProfile={handleUpdateAnswerRawRecDoc}
          loadingComponent={isLoadingModalPdf}
        >
          <div className="contractingRegistrationDocumentsView-card">
            <Grid container lg={12} md={12} sm={12} es={12}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="container-btns-pdf"
              >
                <InputFileHLPure
                  messageBtn={t("digitalContractTemplatesDetail.Document")}
                  flex={true}
                  acceptFile={"application/pdf"}
                  selectedFile={selectedFile}
                  selectedFileName={selectedFileName}
                  errorFile={errorFile}
                  handleFile={e => handleFile(e)}
                  handleDeleteFile={e => handleDeleteFile(e)}
                  tooltipShow={true}
                  positionTooltip={'right'}
                  titleTooltip={'Subir documento'}
                  descriptionTooltip={'Actualiza el documento de la pregunta'}
                  labelActive={false}
                  informationIcon={true}
                />
              </Grid>
              {/*View document*/}
              <Grid container lg={12} md={12} sm={12} es={12}>
                {!isMobile && showAWS ? (
                  <Grid item lg={12} md={12} sm={12} es={12}>
                    {pdfAws}
                  </Grid>
                ) : null}
                {props.selectedFileBase64 && (
                  <React.Fragment>
                    {!isMobile ? (
                      <Grid item lg={12} md={12} sm={12} es={12}>
                        {pdf}
                      </Grid>
                    ) : null}
                    {isMobile && !showAWS ? (
                      <div className="pdf-btn-profile">
                        <DialogPdf blobUrl={blobUrl} />
                      </div>
                    ) : null}
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </div>
        </DialogPdfHLPure>
      )}
    </div>
  );
};

export default ContractGeneratedView;